import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-home-two',
    templateUrl: './home-two.component.html',
    styleUrls: ['./home-two.component.scss']
})
export class HomeTwoComponent implements OnInit {

    constructor(private viewportScroller: ViewportScroller) {}

    public onClick(elementId: string): void { 
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit() {
    }

	isText1Visible: boolean = false;
    isText2Visible: boolean = false;
    isText3Visible: boolean = false;
  
    hideText1(): void {
      this.isText1Visible = false;
    }
  
    hideText2(): void {
      this.isText2Visible = false;
    }
  
    showText1(): void {
      this.isText1Visible = true;
    }
  
    showText2(): void {
      this.isText2Visible = true;
    }

    homeSlides: OwlOptions = {
		loop: true,
		nav: true,
		dots: false,
		autoplayHoverPause: true,
		items: 1,
		autoHeight: true,
		smartSpeed: 750,
		autoplay: true,
		navText: [
			"<i class='fa fa-angle-left'></i>",
			"<i class='fa fa-angle-right'></i>"
		]
    }

}